module.exports = __webpack_public_path__ + "static/media/113.3ea103eb.wav";